<template>
	<AppLayout :title="trans(`errors.http.${code}.title`)" :subtitle="message ?? trans(`errors.http.${code}.subtitle`)">
		<p class="text-9xl font-thin">{{ code }}</p>
		<p v-for="helpMessage in trans('errors.help')" class="text-gray-500">{{ helpMessage }}</p>
	</AppLayout>
</template>
<script setup lang="ts">
import {defineProps} from 'vue'
import {trans} from 'laravel-vue-i18n'
import AppLayout from '@/Layouts/AppLayout.vue'

defineProps<{
	code:number,
	message?:string,
}>()
</script>